import { isValidDateString, toDateString, toUTCDateString, } from '@repo/utils';
export function toPickerDate(value) {
    if (!value)
        return null;
    const day = typeof value === 'string' ? value.slice(0, 10) : toUTCDateString(value);
    const [year, month, dayOfMonth] = day.split('-').map(Number);
    if (!year || !month || !dayOfMonth)
        return null;
    return new Date(year, month - 1, dayOfMonth);
}
/**
 * Un parametro di ricerca come giorno di calendario, o `undefined`. L'URL si
 * scrive anche a mano: tutto ciò che non è un giorno valido si scarta. Un
 * ISO completo tiene la sola parte data; una `Date` (se un reviver è arrivato
 * prima) è un valore date-only a mezzanotte UTC.
 */
function toSearchDay(value) {
    const day = value instanceof Date
        ? Number.isNaN(value.getTime())
            ? undefined
            : toUTCDateString(value)
        : typeof value === 'string'
            ? value.split('T')[0]
            : undefined;
    return day && isValidDateString(day) ? day : undefined;
}
/**
 * Codec di un intervallo di date: nel form è il valore del picker
 * (`{ from?, to? }`, mezzanotte locale), nell'URL due giorni di calendario
 * separati, leggibili e condivisibili. Un intervallo a metà resta a metà.
 */
export function dateRangeParam(fromKey, toKey) {
    return {
        keys: [fromKey, toKey],
        decode(search) {
            const from = toSearchDay(search[fromKey]);
            const to = toSearchDay(search[toKey]);
            if (!from && !to)
                return undefined;
            return {
                from: from ? toPickerDate(from) : undefined,
                to: to ? toPickerDate(to) : undefined,
            };
        },
        encode(value) {
            return {
                [fromKey]: value?.from ? toDateString(value.from) : undefined,
                [toKey]: value?.to ? toDateString(value.to) : undefined,
            };
        },
    };
}
//# sourceMappingURL=date-range-param.js.map